import { TextLinkKind, TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';
import { Messages } from '~src/codegen/Localize';
import { ReactActionDialogBodyProps } from '~src/commonInfra/dialogs/ReactActionDialog';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { IdentityPoolsPicker } from './userImport/IdentityPoolsPicker';

export type IdentityPoolsPickerDialogBodyProps = {
  readonly dialogDescription: string;
  readonly identityPools: IIdentityPool[];
};
export type IdentityPoolsPickerDialogBodyState = { readonly selectedIdentityPool: IIdentityPool };
export type PropsForIdentityPoolsPickerDialogBody = ReactActionDialogBodyProps<IdentityPoolsPickerDialogBodyProps, IdentityPoolsPickerDialogBodyState>;

export function IdentityPoolsPickerDialogBody(props: PropsForIdentityPoolsPickerDialogBody) {

  const [selectedIdentityPool, setSelectedIdentityPool] = React.useState(null as IIdentityPool);

  // Render the identity pools picker drop-down.
  return <>
    <div>
      {props.dialogDescription}
      &nbsp;
      <TextLinkWidget
        testId={'identity-pool-learn-more'}
        target={'_blank'}
        href={HelpService.getServerHelpUrlByCategory('idpools-main')}
        kind={TextLinkKind.Standalone}>
        {Messages.learnMore()}
      </TextLinkWidget>
    </div>

    <div style={{ paddingBottom: CommonStyles.Sizes.LargeSpace, paddingTop: CommonStyles.Sizes.LargeSpace }}>
              <IdentityPoolsPicker identityPools={props.identityPools}
                onOptionSelected={(selectedIdentityPool: IIdentityPool) => {
                  props.updateDialogState({
                    selectedIdentityPool: selectedIdentityPool,
                  });
                  setSelectedIdentityPool(selectedIdentityPool);
                }}
                currentSelection={selectedIdentityPool} />
    </div>
  </>;
}
